import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Tooltip,
  Icon,
} from '@folio/stripes/components';

import {
  RowAsFormElement,
} from '../../../../../../../../common';

import css from './task-status.css';

const TaskStatus = ({
  index,
  statusTranslationKey
}) => {
  return (
    <>
      <div className={css.titleHolder}>
        <span
          data-test-assign-task-status-title
          className={css.title}
        >
          <FormattedMessage id="ui-task-list.job.assignTasks.field.status" />
        </span>
        <Tooltip
          id={`tooltip-status-for-row-${index}`}
          text={<FormattedMessage id="ui-task-list.job.assignTasks.tooltip.status" />}
        >
          {({ ref, ariaIds }) => (
            <span
              ref={ref}
              aria-labelledby={ariaIds.text}
              className={css.icon}
            >
              <Icon icon="info" />
            </span>
          )}
        </Tooltip>
      </div>
      <RowAsFormElement>
        <FormattedMessage id={statusTranslationKey} />
      </RowAsFormElement>
    </>
  );
};

TaskStatus.propTypes = {
  index: PropTypes.number.isRequired,
  statusTranslationKey: PropTypes.string.isRequired,
};

export default TaskStatus;
